var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9609 5.29043C14.8627 4.99462 14.5933 4.78452 14.2745 4.75654L9.94515 4.37368L8.23319 0.47114C8.10695 0.185135 7.81947 0 7.50006 0C7.18065 0 6.89317 0.185134 6.76693 0.471809L5.05497 4.37368L0.724884 4.75654C0.406731 4.78519 0.138017 4.99462 0.0392523 5.29043C-0.0595126 5.58625 0.031699 5.91071 0.272374 6.11523L3.54489 8.91042L2.5799 13.0504C2.50929 13.3548 2.6306 13.6694 2.88993 13.852C3.02932 13.9501 3.1924 14 3.35686 14C3.49865 14 3.63931 13.9628 3.76554 13.8892L7.50006 11.7154L11.2332 13.8892C11.5064 14.0493 11.8507 14.0347 12.1095 13.852C12.3689 13.6689 12.4901 13.3541 12.4195 13.0504L11.4545 8.91042L14.7271 6.11579C14.9677 5.91071 15.0596 5.5868 14.9609 5.29043Z",
    fill: "#27D639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/greenStar.24c3378463a8a50515699b249e788c5a.svg";
export { ForwardRef as ReactComponent };